import get from "lodash/get";
import { TRUSTPILOT_SCRIPT_SRC } from "~/components/TrustpilotWidget";
import { User } from "~/entities/user/types";
import useStructuredData from "~/hooks/useStructuredData";

const Scripts: React.FC<{ nonce: string; user: User | null }> = ({
  nonce,
  user,
}) => {
  const structuredData = useStructuredData();
  const productSnippet = get(structuredData, "productSnippet");
  const productGroup = get(structuredData, "productGroup");

  return (
    <>
      {!user?.doNotSellMyInformation && (
        <>
          <script
            nonce={nonce}
            data-testid="frontAppChat"
            src="https://chat-assets.frontapp.com/v1/chat.bundle.js"
          />
          <script
            nonce={nonce}
            id="merchantWidgetScript"
            src="https://www.gstatic.com/shopping/merchant/merchantwidget.js"
            defer
          />
        </>
      )}
      <script
        data-testid="trustpilot-script"
        nonce={nonce}
        src={TRUSTPILOT_SCRIPT_SRC}
        async
      />
      {productSnippet && (
        <script
          id="product_snippet_json"
          data-testid="product_snippet_json"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSnippet),
          }}
        />
      )}
      {productGroup && (
        <script
          id="product_group_json"
          data-testid="product_group_json"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productGroup),
          }}
        />
      )}
    </>
  );
};

export default Scripts;
